import {
    doNotModifyCodeAbove,
    doNotModifyCodeBelow,
} from "@js/educationContent/CairoMummiesContent/eduConstants";

export const lesson4DefaultStartCode = `%lang starknet
${doNotModifyCodeAbove}`;

export const lesson4DefaultMiddleCode = `// TODO: Create a struct here so the test passes`;

export const lesson4DefaultEndCode = `${doNotModifyCodeBelow}
@external
func test_currency_sum{syscall_ptr : felt*}() {
    alloc_locals;
    local euro : Currency = Currency('Euro', 2);
    assert euro.name = 'Euro';
    return ();
}`;
